import { registerShortcut } from '@/shared/lib/shortcutRegistry';
import { useSidebarStore } from '@/shared/stores/sidebarStore';

/**
 * App-wide keyboard shortcuts — bound to global chrome, not owned by any single
 * page. Their handlers are registered once at bootstrap ({@link registerAppShortcuts},
 * called from `main.tsx`) so they work on every route, mirroring
 * `registerAppDialogs`. Feature/page-owned shortcuts register on mount via
 * `useRegisterShortcut` instead.
 *
 * Keys and scope live in the central `SHORTCUTS` config; this file only binds
 * handlers to command ids.
 */

/** Toggle the primary nav rail (same `open` flag at every viewport width). */
function toggleSidebar(): void {
  useSidebarStore.getState().toggleOpen();
}

/** Register the app-wide command handlers. Call once at startup, before the app renders. */
export function registerAppShortcuts(): void {
  registerShortcut('sidebar.toggle', toggleSidebar);
}
